import { render, staticRenderFns } from "./OrgManagement.vue?vue&type=template&id=757393c1&"
import script from "./OrgManagement.vue?vue&type=script&lang=ts&"
export * from "./OrgManagement.vue?vue&type=script&lang=ts&"
import style0 from "./OrgManagement.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports